import Background from 'Components/Reusable/Background/Background';
import OverlapCard from 'Components/Reusable/Cards/OverlapCard';
import React, { Fragment, useEffect, useState } from 'react';
import payment from 'Assets/img/svg/icons/payment.svg';
import { information } from 'Utils/information';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { BackButton, CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { createSubscription, upgradeSubscription } from 'ReduxStore/subscription/Action';
import { useHistory } from 'react-router-dom';
import { RootState } from 'ReduxStore/store';
import { Routes } from 'Utils/Route';
import { useParams } from 'react-router-dom';
import { Bounce } from 'react-awesome-reveal';
import * as yup from 'yup';
import { changeIdentities } from 'Helpers';
import { createPayment, sendPaymentDataToAnet } from 'Helpers/authorizeNet';
import ClipLoader from 'react-spinners/ClipLoader';
import backButton from 'Assets/img/svg/buttons/back.svg';
import { GetAllKids } from 'ReduxStore/children/Action';
import { Helmet } from 'react-helmet';
interface RouteParams {
	id: string;
}

interface State {
	card: string;
	CVV: string;
	expiry: string;
}

const validationSchema = yup.object({
	card: yup
		.string()
		.required('Card number is required')
		.length(16, 'Invalid credit card number. Please try again'),
	cvv: yup.string().required('CVV number is required').length(3, 'Provide a valid cvv'),
	expiry: yup.string().required('Expiration date is required').length(4, 'Enter a valid year'),
});

const scriptLoaded = () => {
	// eslint-disable-next-line no-console
	console.log('window here', window.Accept, window);
	return window;
};

const loadScript = (src: any) => {
	const tag = document.createElement('script');
	tag.src = src;
	// document.body.appendChild(tag);
	const script = document.createElement('script');
	script.src = src;
	script.async = false;
	return document.getElementsByTagName('body')[0].appendChild(tag);
};

const Upgrade = () => {
	useEffect(() => {
		loadScript(
			process.env.NODE_ENV != 'production'
				? 'https://jstest.authorize.net/v3/AcceptUI.js'
				: `<script type="text/javascript" src="https://jstest.authorize.net/v1/Accept.js" charset="utf-8"></script>`,
		);
		dispatch(GetAllKids());
	}, []);
	const [billingSuccess, setBillingSuccess] = useState(false);
	const params = useParams<RouteParams>();
	const [authorizeError, setAuthorizeError] = useState<any>('');
	const history = useHistory();
	const matches = useMediaQuery('(max-width:550px)');
	const [values, setValues] = React.useState<State>({
		card: '',
		CVV: '',
		expiry: '',
	});
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const isBilled = useSelector((state: RootState) => state.subscriptions.isBilled);
	const childId = params.id;
	const formik = useFormik({
		initialValues: {
			card: '',
			cvv: '',
			expiry: '',
		},

		validationSchema: validationSchema,
		onSubmit: async values => {
			setLoading(!loading);
			const data = await sendPaymentDataToAnet(values.card, values.expiry, values.cvv, window.Accept);
			const nonce = await createPayment(data, window.Accept, setAuthorizeError, setLoading);

			setTimeout(() => {
				upgradeSubscription(nonce.dataDescriptor, nonce.dataValue, 'premium', '60', childId)(dispatch);
				setBillingSuccess(true);
				setLoading(!loading);
			}, 10500);
		},
	});

	// if (billingSuccess) {
	// 	history.push(`/premium-congratulations/${params.id}`);
	// }
	// eslint-disable-next-line no-console
	console.log(isBilled, 'billing status');
	useEffect(() => {
		isBilled && history.push(`/congratulations/${params.id}`);
	}, []);

	useEffect(() => {
		isBilled && history.push(`/congratulations/${params.id}`);
	}, [isBilled]);

	const children = useSelector((state: RootState) => state.children.children);
	const getChildId = params.id;
	const child = children && children.find(child => child.id === parseInt(getChildId));

	const errors = useSelector((state: RootState) => state.subscriptions.errors);
	return (
		<Fragment>
			<Background
				backgroundColor="#FFBD89"
				height={matches ? 'auto' : '100vh'}
				overflow="auto"
				position="sticky"
			>
				<BackButton image={backButton} transparent />
				<OverlapCard
					heading={child && changeIdentities(information.payment.heading, child.fullName, child?.gender)}
					subheading={information.payment.subheading}
					information={child && changeIdentities(information.premium.info, child.fullName, child?.gender)}
					common={{ margin: '-3rem auto 2rem', width: '80%' }}
					image={payment}
					upper
				>
					{authorizeError ? (
						<div className="d-flex justify-content-center pt-3" style={{ color: 'red' }}>
							<span>{authorizeError}</span>
						</div>
					) : (
						''
					)}
					{errors && errors.message != null ? (
						<div className="d-flex justify-content-center pt-3">
							<span>{errors.error}</span>
						</div>
					) : (
						''
					)}
					{errors && errors != null ? (
						<div className="d-flex justify-content-center pt-3" style={{ color: 'red' }}>
							<span>{errors}</span>
						</div>
					) : (
						''
					)}
					<p className="text-center d-flex justify-content-center my-4">Total Amount: $60</p>
					<small className="text-center d-flex justify-content-center my-4">Payment information</small>
					<form
						onSubmit={formik.handleSubmit}
						className={`${
							matches ? 'w-100' : ''
						} d-flex flex-column align-items-center flex-nowrap justify-content-center px-5`}
					>
						<ReusableInput
							name="card"
							type="text"
							placeholder="Enter your card number"
							formik={formik}
							width={matches ? '100%' : '383.87px'}
							height="53.91px"
							label="Card Number"
						/>
						<div
							className="align-items-center flex-nowrap d-flex justify-content-between "
							style={{ flexDirection: matches ? 'column' : 'row' }}
						>
							<div className="mx-2 my-3">
								<ReusableInput
									name="expiry"
									type="text"
									placeholder="0822"
									formik={formik}
									// width="180.79px"
									width={matches ? '100%' : '180.79px'}
									label="Valid To:"
								/>
							</div>

							<div className="mx-2 my-3">
								<ReusableInput
									name="cvv"
									type="text"
									placeholder="CVV"
									formik={formik}
									width={matches ? '100%' : '150.79px'}
									label="CVV"
								/>
							</div>
						</div>
						<Bounce>
							<CommonButton
								command={loading ? 'PAY NOW' : <ClipLoader color={'white'} loading={true} size={30} />}
								common={{
									width: matches ? '100%' : '381.87px',
									height: '48px',
									margin: '2rem auto',
									background: '#7FD6DD',
									radius: '200px',
									fontSize: '20px',
								}}
							/>
						</Bounce>
					</form>
				</OverlapCard>
			</Background>
			<Helmet>
				{process.env.REACT_APP_NODE_ENV != 'production' ? (
					<script
						type="text/javascript"
						src="https://jstest.authorize.net/v1/Accept.js"
						charSet="utf-8"
					></script>
				) : (
					<script type="text/javascript" src="https://js.authorize.net/v1/Accept.js" charSet="utf-8"></script>
				)}
			</Helmet>
		</Fragment>
	);
};

export default Upgrade;
